module.exports = "<div layout=\"column\" layout-align=\"space-between stretch\" ng-cloak>\n    <md-button ng-repeat=\"parameter in $ctrl.pedagogicalApproachParams\" class=\"md-accent md-raised text-capitalize\"\n               ng-class=\"$ctrl.isCurrentGoal(parameter.index) ? 'md-hue-1' : 'md-hue-2' \"\n               ng-click=\"$ctrl.gotoTab(parameter.index)\">\n        {{ parameter.name }}\n    </md-button>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/evaluation/pages/stepLearningGoals/parametersList/parameterListView.html
// module id = 508
// module chunks = 0